import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import createSelectors from '../utils/createSelectors'

interface State {
  firstRender: boolean
  isHidden: boolean
}
interface Action {
  setIsHidden: (isBannerHidden: State['isHidden']) => void
  setFirstRender: (firstRender: State['firstRender']) => void
}

const baseStorePopUp = create<State & Action>()(
  persist(
    (set) => ({
      firstRender: true,
      isHidden: true,
      setIsHidden: (isHidden) => set(() => ({ isHidden })),
      setFirstRender: (firstRender) => set(() => ({ firstRender }))
    }),
    {
      name: 'pop-up',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isHidden: state.isHidden,
        firstRender: state.firstRender
      })
    }
  )
)

const useStorePopUp = createSelectors(baseStorePopUp)

export default useStorePopUp
